import { footerColumns } from "@/mocks/melonData";

export default function MelonFooter() {
  return (
    <footer className="bg-accent-50/60 border-t border-accent-100 mt-2">
      <div className="mx-auto max-w-6xl px-4 md:px-6 pt-14 pb-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="relative flex w-9 h-9 items-center justify-center rounded-xl bg-primary-500 text-background-50 font-heading text-lg overflow-hidden">
                瓜
                <span className="absolute -bottom-2 -right-2 w-4 h-4 rounded-full bg-accent-400" />
              </span>
              <span className="font-heading text-2xl text-foreground-950">每日有瓜</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-7 text-foreground-600">
              追踪每颗娱乐大瓜的后续、反转与最新进展。点开看瓜的下回分解，跟随跟进结果，不错过任何剧情走向。一颗瓜，我们帮你看到底。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-weibo-fill", "ri-douban-fill", "ri-bilibili-fill", "ri-wechat-fill"].map((ic) => (
                <a
                  key={ic}
                  href="#top"
                  aria-label="关注每日有瓜"
                  className="inline-flex w-10 h-10 items-center justify-center rounded-lg bg-background-50 text-foreground-700 hover:bg-primary-500 hover:text-background-50 border border-background-200 transition-colors"
                >
                  <i className={`${ic} text-lg`} />
                </a>
              ))}
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title} className="md:col-span-2">
              <h4 className="text-sm font-semibold text-foreground-950">{col.title}</h4>
              <ul className="mt-4 space-y-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a href={l.href} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-3">
            <h4 className="text-sm font-semibold text-foreground-950">联系瓜田</h4>
            <ul className="mt-4 space-y-3 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-foreground-500" />
                editor@mrgua.example.cn
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-edit-line text-foreground-500" />
                投稿线索 · 每日接收
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-foreground-500" />
                追更时段 09:00 - 24:00
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-accent-200/70 pt-6">
          <p className="text-xs text-foreground-600">
            © {new Date().getFullYear()} 每日有瓜 · 本页内容为资讯聚合与动态整理，非新闻通讯社官方发布。
          </p>
          <div className="flex items-center gap-5">
            {["关于我们", "常见问题", "投稿指南"].map((t) => (
              <a key={t} href="#faq" className="text-xs text-foreground-600 hover:text-primary-600 transition-colors">
                {t}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}